// src/utils/guestStorage.js

const STORAGE_KEY = "guestScans";

// ✅ Ajouter un scan invité (évite doublons consécutifs)
export function saveGuestScan(scan) {
  try {
    const scans = getGuestScans();
    const last = scans[scans.length - 1];
    if (last?.id === scan.id) return; // Empêche le même scan juste après
    scans.push(scan);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(scans));
  } catch (err) {
    console.warn("Erreur enregistrement invité:", err);
  }
}

// ✅ Récupérer tous les scans invités
export function getGuestScans() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
  } catch (err) {
    console.warn("Erreur lecture stockage invité:", err);
    return [];
  }
}

// ✅ Supprimer tous les scans invités
export function clearGuestScans() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (err) {
    console.warn("Erreur suppression historique invité:", err);
  }
}
